import { Injectable } from '@angular/core';
import { StorageKeys, ConfigStrings, ErrorCodes } from 'src/app/utils/common-classes';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MatDialog } from '@angular/material';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private token: string;

  constructor(private httpClient: HttpClient,
    private dialogRef: MatDialog) {
    this.token = localStorage.getItem(StorageKeys.TOKEN);
  }

  public getToken(): string {
    return this.token;
  }

  public setToken(token: string): void {
    this.token = token;
    localStorage.setItem(StorageKeys.TOKEN, token);
  }

  public getHeaders(): HttpHeaders {
    let _self = this;
    if (_self.token) {
      return new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8', 'Authorization': 'Bearer ' + this.token });
    } else {
      return new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
    }
  }

  public login(username: string, password: string): Promise<string> {
    let _self = this;
    return new Promise((resolve, reject) => {
      const headers = _self.getHeaders();
      const body = { email: username, password: password, tenantId: 'elettric80' };
      _self.httpClient.post(ConfigStrings.API_URL + "/login", body, { headers: headers }).subscribe((data: any) => {
        if (data && data.token) {
          _self.setToken(data.token);
          resolve();
        } else {
          reject(new Error(ErrorCodes.UNKNOWN_ERROR));
        }
      }, (error: any) => {
        reject(error);
      });
    });
  }

  public logout(): Promise<void> {
    let _self = this;
    _self.dialogRef.closeAll();
    return new Promise((resolve, reject) => {
      new Promise((innResolve, innReject) => {
        const headers = _self.getHeaders();
        _self.httpClient.post(ConfigStrings.API_URL + "/logout", null, { headers: headers }).subscribe(() => {
          innResolve();
        }, (error: any) => {
          innReject(error);
        });
      }).then(() => {
        return Promise.resolve();
      }).catch((err) => {
        console.error(err);
        return Promise.resolve();
      }).then(() => {
        _self.removeToken();
        resolve();
      });
    });
  }

  private removeToken(): void {
    this.token = null;
    localStorage.removeItem(StorageKeys.TOKEN);
  }

}
